// Keyboard shortcuts. Legacy: global keydown handler + nudge (L6788-6834).
// Phase 1 wires the shortcuts whose targets exist now; the rest (group/export/
// print/save) are added as their modules land.
import { getCanvas, state } from './state'
import { undo, redo } from './history'
import { copySelected, pasteFromClipboard, duplicateSelected, deleteSelected, selectAll } from './clipboard'
import { addText } from './widgets/text'
import { addShape } from './widgets/shapes'
import { zoomIn, zoomOut, fitToView } from './canvas'
import { groupSelected, ungroupSelected } from './ui/toolbar'
import { printCurrentLabel, openExportModal } from './export'

function nudge(dx: number, dy: number, shift: boolean): void {
  const canvas = getCanvas()
  const obj = canvas.getActiveObject()
  if (!obj) return
  const step = shift ? 10 : 1
  obj.set({ left: (obj.left ?? 0) + dx * step, top: (obj.top ?? 0) + dy * step } as any)
  obj.setCoords()
  canvas.requestRenderAll()
}

export function initKeyboard(): void {
  document.addEventListener('keydown', (e) => {
    const target = e.target as HTMLElement | null
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) return

    const active = state.canvas?.getActiveObject() as any
    if (active && active.isEditing) return

    const ctrl = e.ctrlKey || e.metaKey

    if (ctrl && e.key === 'z') { e.preventDefault(); void undo() }
    else if (ctrl && (e.key === 'y' || (e.shiftKey && e.key === 'Z'))) { e.preventDefault(); void redo() }
    else if (ctrl && e.key === 'c') { e.preventDefault(); void copySelected() }
    else if (ctrl && e.key === 'v') { e.preventDefault(); void pasteFromClipboard() }
    else if (ctrl && e.key === 'd') { e.preventDefault(); void duplicateSelected() }
    else if (ctrl && e.key === 'a') { e.preventDefault(); selectAll() }
    else if (e.key === 'Delete' || e.key === 'Backspace') { deleteSelected() }
    else if (e.key === 't' || e.key === 'T') { addText() }
    else if (e.key === 'r' || e.key === 'R') { addShape('rect') }
    else if (e.key === '0') { fitToView() }
    else if (e.key === '+' || e.key === '=') { zoomIn() }
    else if (e.key === '-') { zoomOut() }
    else if (e.key === 'ArrowLeft') { nudge(-1, 0, e.shiftKey) }
    else if (e.key === 'ArrowRight') { nudge(1, 0, e.shiftKey) }
    else if (e.key === 'ArrowUp') { nudge(0, -1, e.shiftKey) }
    else if (e.key === 'ArrowDown') { nudge(0, 1, e.shiftKey) }
    else if ((e.key === 'g' || e.key === 'G') && (e.ctrlKey || e.metaKey)) {
      e.preventDefault()
      if (e.shiftKey) ungroupSelected()
      else groupSelected()
    }
    else if ((e.key === 'p' || e.key === 'P') && (e.ctrlKey || e.metaKey)) { e.preventDefault(); void printCurrentLabel() }
    else if ((e.key === 'e' || e.key === 'E') && (e.ctrlKey || e.metaKey)) { e.preventDefault(); openExportModal() }
    // TODO: Ctrl+S save (Phase 4).
  })
}
